// require('bootstrap');
require('./plugins/finaltileslayout');
import { UI } from './modules/theme/ui.js';
import cssVars from 'css-vars-ponyfill';

document.addEventListener('DOMContentLoaded',() => {
    // UI Theme
    const ui = new UI();
    var MSLegacy = ui.checkForIE();

    if (MSLegacy !== false) {
        var body = document.body.classList.add('internet-explorer');
        // var insert = document.getElementsByTagName('head')[0];
        // var script = document.createElement('script');
        // script.setAttribute('src', '/js/css-vars-ponyfill.min.js');
        // insert.appendChild(script);
        cssVars({
            // Targets
            rootElement   : document,
            shadowDOM     : false,

            // Sources
            include       : 'link[rel=stylesheet],style',
            exclude       : '',
            variables     : {
                '--bs-gutter-x': '1.5rem',
                '--bs-gutter-y': '0',
            },

            // Options
            onlyLegacy    : true,
            preserveStatic: true,
            preserveVars  : false,
            silent        : false,
            updateDOM     : true,
            updateURLs    : true,
            watch         : false,
        });
    }
})